export default "__VITE_ASSET__CVR8Wmhe__"